import { render, staticRenderFns } from "./showroom-page.vue?vue&type=template&id=535b1a53"
import script from "./showroom-page.vue?vue&type=script&lang=js"
export * from "./showroom-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports